import React from 'react';
import { connect } from "react-redux";
import { BsBackspaceFill } from 'react-icons/bs'
//import { store } from 'react-notifications-component';
//import updateItem from './../../../../API/Provider/UpdateMenasOfPayment'
import Loader from './../../../../Global/loader'
import { withNamespaces } from 'react-i18next';
import GetCountries from './../../../../API/Client/GetCountries'
import Select from 'react-select'
import { Button, Row, Col, Form } from "react-bootstrap";

class UpdateNaciniPlacanja extends React.Component {
    constructor(props) {
        super(props); 
        this.submitUpdate = this.submitUpdate.bind(this);
    }

    state={
        loading: false,

        countries: [],
        pickedCountry: null,

        fiscalization_label_list:[
            { value: 'G', label: 'G' },
            { value: 'K', label: 'K' },
            { value: 'T', label: 'T' },
            { value: 'C', label: 'C' },
            { value: 'O', label: 'O' }
        ],
        pickedFiscalizationlabel: {}
    }

    componentDidMount = async () => {
        this.setState({ loading: true})
        //get countries
        let items = await GetCountries()       
        let countryList = []
        
        await items.data.countries
            .map((data, index) =>{
            let oneItem = {value: data.uuid , label: data.country_name }
            countryList.push(oneItem)
            return null
        })       

        let pickedCountry = countryList.filter((data) => data.value === this.props.oneMeansOfPayment.country_uuid)   

        let pickedFiscalization = this.state.fiscalization_label_list.filter((data) => data.Form.Label === this.props.oneMeansOfPayment.fiscalization_label)   
        await this.setState({
            countries: countryList,
            pickedCountry: pickedCountry[0],
            pickedFiscalizationlabel: pickedFiscalization[0]
        })
        
        this.setState({ loading: false})
    }

    changeFiscalizationLabel(e){
        this.setState({
            pickedFiscalizationlabel: e
        })
    }

    handleCountryChange(e){    
        this.setState({
            pickedCountry: e
        })                  
    }

    handleChange = async (e) => {
        await this.props.mapState("CHANGE_ONE_MEANS_OF_PAYMENT", e.target) 
    }

    submitUpdate = async (e) =>{
        //const { t } = this.props

        e.preventDefault()
        /*
        let update = await updateItem(this.props.oneMeansOfPayment, this.state.pickedCountry.value, this.state.pickedFiscalizationForm.Label.value)
        
        if(update.data.status === 200){
            store.addNotification({
                title: t('Success!'),
                message: t('The Client type has been changed'),
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });
        }
        else(
            store.addNotification({
                title: t('Error!'),
                message: t("An error occurred while changing the client type, please try again."),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })
        )
        */
        this.props.goBack()
    }

    render(){  
        const { t } = this.props

        return (
            this.state.loading ?
                <Loader />
            :
            <Form className="form-container">
                <Row>        
                    <Col sm={12} lg={6} xl={4}>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label htmlFor="description" column sm={2} md={4}>{t('Description')}</Form.Label>
                            <Col sm={10} md={8}>
                                <Form.Control        
                                        id="description"                          
                                        type="text"
                                        value={this.props.oneMeansOfPayment.description}
                                        onChange={e => this.handleChange(e)}
                                    />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label htmlFor="country" column sm={2} md={4}>{t('Country')}</Form.Label>
                            <Col sm={10} md={8}>
                                <Select
                                    options={this.state.countries} 
                                    onChange={(values) => this.handleCountryChange(values)}
                                    isClearable
                                    isInvalid={this.state.pickedCountry === null}
                                    value={this.state.pickedCountry}
                                />                                  
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label htmlFor="fiscalization_label" column sm={2} md={4}>{t('Fiscalization Form.Label')}</Form.Label>
                            <Col sm={10} md={8}>
                                <Select
                                    options={this.state.fiscalization_label_list} 
                                    onChange={data => this.changeFiscalizationLabel(data)}
                                    value={this.state.pickedFiscalizationForm.Label}
                                />   
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label htmlFor="allowed_invoice_types" column sm={2} md={4}>{t('Allowed invoice types')}</Form.Label>
                            <Col sm={10} md={8}>
                                <Form.Control        
                                        id="allowed_invoice_types"                          
                                        type="text"
                                        value={this.props.oneMeansOfPayment.allowed_invoice_types}
                                        onChange={e => this.handleChange(e)}
                                    />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Col sm={12} className="text-center">
                                <Button                                     
                                    className="btnSpremi"
                                    onClick={(e) => this.submitUpdate(e)}
                                >
                                    {t('Save')}
                                </Button>
                            </Col> 
                        </Form.Group>                                  
                    </Col>
                </Row>           
                
                <Row className="back-button-container">
                    <Button 
                        variant='default'
                        className="btn-default mt-2 mb-2"
                        onClick={() => this.props.goBack()}
                    >
                        <BsBackspaceFill size={30} />  <strong>{t('Back')}</strong>
                    </Button>
                </Row>
            </Form>
        )
    }
}
const mapStateToProps = state => {
    return {
        oneMeansOfPayment: state.codeBook.oneMeansOfPayment
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(UpdateNaciniPlacanja));


